import { render } from "./Endorse.vue?vue&type=template&id=49c3ac6e&scoped=true"
import script from "./Endorse.vue?vue&type=script&lang=js"
export * from "./Endorse.vue?vue&type=script&lang=js"

import "./Endorse.vue?vue&type=style&index=0&id=49c3ac6e&scoped=true&lang=scss"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c3ac6e"]])

export default __exports__